// @ts-nocheck
import * as GraphQLSchema from '../graphql-types';

import * as Operations from './terminate-agreement-mutation.graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type TerminateAgreementMutationVariables = GraphQLSchema.Exact<{
  TerminateAgreementInput: GraphQLSchema.TerminateAgreementInput;
}>;


export type TerminateAgreementMutation = { __typename?: 'Mutation', terminateAgreement?: { __typename?: 'TerminateAgreementPayload', agreement: { __typename?: 'Agreement', id: string, uuid?: string | null, status: string, otherUser: { __typename?: 'User', id: string, uuid?: string | null, accountType: GraphQLSchema.UserAccountTypes }, currentUser?: { __typename?: 'User', id: string, uuid?: string | null } | null, job?: { __typename?: 'PostedJob', id?: string | null, uuid?: string | null, jobKind: { __typename?: 'JobKind', kind: GraphQLSchema.PostedJobKindOptions }, status: { __typename?: 'JobStatus', clientStatusDescription?: string | null } } | null } } | null };


  @Injectable({
    providedIn: 'root'
  })
  export class TerminateAgreementMutationService extends Apollo.Mutation<TerminateAgreementMutation, TerminateAgreementMutationVariables> {
    document = Operations.TerminateAgreementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }